module.exports = __webpack_public_path__ + "img/wow.1ede03a5.svg";